<template>
    <!-- begin:: Page -->
    <div class="m-grid m-grid--hor m-grid--root m-page outer-box">
        <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin"
             id="m_login">
            <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
                <div class="m-stack m-stack--hor m-stack--desktop">
                    <div class="m-stack__item m-stack__item--fluid">
                        <div class="m-login__wrapper">
                            <h1 class="m-login__logo" >
                                修改密码
                            </h1>
                            <div class="m-login__signin">
                                <!--                                <div class="m-login__head">-->
                                <!--                                    <h3 class="m-login__title">登陆面板</h3>-->
                                <!--                                </div>-->
                                <div class="m-login__form m-form">
                                    <div class="form-group m-form__group">
                                        <input class="form-control m-input m-login__form-input--last"
                                               v-model="changePasswordForm.phone"  placeholder="请输入账号"
                                               name="password">
                                    </div>
                                    <div class="form-group m-form__group">
                                        <input class="form-control m-input m-login__form-input--last"
                                               v-model="changePasswordForm.password" type="password" placeholder="请输入新密码"
                                               name="password">
                                    </div>
                                    <div class="form-group m-form__group">
                                        <input class="form-control m-input m-login__form-input--last"
                                               v-model="changePasswordForm.password2" type="password" placeholder="请重复密码"
                                               name="password">
                                    </div>
                                    <div  class="form-group m-form__group">
                                        <div style="float:left;width: 200px">
                                            <input v-model="changePasswordForm.code" placeholder="请输入验证码"
                                                      class="form-control m-input m-login__form-input--last">
                                        </div>
                                        <div style="float:right">
                                            <el-button  type="primary" round size="mini"
                                                        @click="handleGetCode" :loading="button_loading">获取验证码</el-button>
                                        </div>
                                    </div>
                                    <div style="clear: both"></div>
                                    <div class="m-login__form-action">
                                        <button class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air"
                                                @click="handleChange" :loading="button_loading">确定
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1	m-login__content m-grid-item--center"
                 style="background-image: url(/media/img/bg/bg-4.jpg)">
                <div class="m-grid__item">
                    <h3 class="m-login__welcome">学枝系统</h3>
                    <p class="m-login__msg">
                        <!--Lorem ipsum dolor sit amet, coectetuer adipiscing<br>elit sed diam nonummy et nibh euismod-->
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "changePassword",
        data() {
            return {
                path: "/user/base",
                button_loading: false,
                changePasswordForm:{
                    phone:'',
                    password:'',
                    password2:'',
                    code:''
                },
            }
        },
        created() {
            this.handleCreate();
        },
        beforeDestroy(){
            this.changePasswordForm={
                    phone:'',
                    password:'',
                    password2:'',
            }
            this.$wApi.removeListen(this.path)
        },
        methods: {
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':

                        break;
                    case 'change_user_password':
                        this.$message.success('修改成功');
                        this.button_loading=false;
                        this.router.push({path: '/login'});
                        break;
                    case 'get_captcha':
                        this.$message.success('发送成功');
                        this.button_loading=false;
                        break;
                    case 'get_captcha_error':
                        this.button_loading=false;
                        break;
                }
            },
            handleChange(){
                this.button_loading=true;
                this.$wApi.send(this.path, 'change_user_password', {
                    'phone': this.changePasswordForm.phone,
                    'password': this.changePasswordForm.password,
                    'password2': this.changePasswordForm.password2,
                    'code':this.changePasswordForm.code
                });
            },
            handleGetCode(){
                this.button_loading=true;
                this.$wApi.send(this.path, 'get_captcha', {
                    'phone': this.changePasswordForm.phone,
                });
            }
        }
    }
</script>

<style scoped lang="scss">

    .top-right {
        float: right;
        color: #fff;

    }

    .login {
        background-color: #161931;
        height: 100%;

        header {
            height: 40px;
            background-color: #fff;

            .right-menu {
                margin: 0;
                position: fixed;
                top: 0;
                right: 5px;
                display: flex;
                flex-direction: row;
                height: 40px;
                justify-content: center;
                align-items: center;
                z-index: 2000;

                li {
                    margin-left: 10px;
                    color: #788db4;
                    font-size: 15px;
                    flex: 1;
                    list-style-type: none;
                    padding: 8px 10px;
                }

                li:hover {
                    color: #6f42c1;
                    font-size: 15px;
                    flex: 1;
                    list-style-type: none;
                    background: rgba(0, 123, 255, 0.05);
                    border-radius: 5px;
                    cursor: pointer;
                }
            }

        }

        .login-button {
            width: 100%;
        }

        .logo {
            width: 200px;
        }

        .code{
            width: 400px;
            display: flex;
            justify-content:space-between;
        }
    }
</style>
